import axios from "axios";

export const baseUrl = "https://web-api.threecircle5.com";

export const apiCallback = axios.create({
  withCredentials: false,
  baseURL: baseUrl,
});
